import { render } from "./ListePiece.vue?vue&type=template&id=2308a148&ts=true"
import script from "./ListePiece.vue?vue&type=script&lang=ts"
export * from "./ListePiece.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__